import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { fetchOk } from '@atlassian/mpac-fetch-wrapper';
import { CompatibleProductId } from '@atlassian/mpac-types';
import { print } from 'graphql';
import groupBy from 'lodash/groupBy';
import { calculateRetries, setProp, transformToPaymentModel } from '../connect/Util';
import { buildProductCloudAppUrls } from './helpers';
var appInstallationTask = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "appInstallationTask" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "id" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } }, directives: [] }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "appInstallationTask" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "id" } } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "state" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "errors" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" }, arguments: [], directives: [] }] } }] } }] } }], loc: { start: 0, end: 571, source: { body: "# If you are making any change here\n# Do thoroughly read our graphql contribution guidelines\n# https://bitbucket.org/atlassian-marketplace/marketplace-frontend/src/master/docs/working-with-graphql.md\n\nmutation ecosystemCloudAppInstall($input: AppInstallationInput!) {\n  installApp(input: $input) {\n    success\n    installationId\n    taskId\n    errors {\n      message\n      extensions {\n        statusCode\n        errorType\n      }\n    }\n  }\n}\n\nquery appInstallationTask($id: ID!) {\n  appInstallationTask(id: $id) {\n    id\n    state\n    errors {\n      message\n    }\n  }\n}\n", name: "GraphQL request", locationOffset: { line: 1, column: 1 } } } };
export const toEcosystemCloudInstallableAddon = marketplaceApp => {
  var _marketplaceApp$versi;
  const cloudAppsDeployment = (_marketplaceApp$versi = marketplaceApp.version) === null || _marketplaceApp$versi === void 0 ? void 0 : _marketplaceApp$versi.deployment;
  const details = {
    key: marketplaceApp.appKey,
    name: marketplaceApp.name,
    description: marketplaceApp.tagline || '',
    metadata: {},
    ecosystemCloudAppId: cloudAppsDeployment.cloudAppId
  };
  const installableAddon = {
    details,
    preinstalled: false,
    scopes: cloudAppsDeployment.scopes.map(s => s.capability),
    metadata: undefined,
    eligibleForFreeOnSandbox: false,
    // defaulted to false for the forge apps as they are not eligible for free installation on sandbox
    cloudMigrationTrial: {
      isEligible: false
    },
    parentCapabilitySet: undefined
  };
  return installableAddon;
};
export const toInstalledEcosystemCloudAddon = (product, baseUrl, marketplaceInstallation, appGlobalSettingsExtensions) => {
  var _marketplaceInstallat, _marketplaceAppData$v, _marketplaceAppData$v2;
  const marketplaceAppData = (_marketplaceInstallat = marketplaceInstallation.app) === null || _marketplaceInstallat === void 0 ? void 0 : _marketplaceInstallat.marketplaceApp;
  const getStartedExtension = appGlobalSettingsExtensions.find(extension => {
    var _extension$properties;
    return (_extension$properties = extension.properties) === null || _extension$properties === void 0 ? void 0 : _extension$properties.useAsGetStarted;
  });
  const configExtension = appGlobalSettingsExtensions.find(extension => {
    var _extension$properties2;
    return ((_extension$properties2 = extension.properties) === null || _extension$properties2 === void 0 ? void 0 : _extension$properties2.useAsConfig) || extension.type === 'compass:adminPage';
  });
  const version = marketplaceAppData && ((_marketplaceAppData$v = marketplaceAppData.versions.edges) === null || _marketplaceAppData$v === void 0 ? void 0 : (_marketplaceAppData$v2 = _marketplaceAppData$v[0]) === null || _marketplaceAppData$v2 === void 0 ? void 0 : _marketplaceAppData$v2.node);
  if (marketplaceAppData && version) {
    var _marketplaceInstallat2, _marketplaceInstallat3;
    const details = {
      key: marketplaceAppData.appKey,
      name: marketplaceAppData.name,
      description: marketplaceAppData.tagline || '',
      metadata: undefined
    };
    const marketplaceCloudAppDeployment = version.deployment;
    const authType = {
      type: '2LO'
    };
    const paymentModel = transformToPaymentModel(version, marketplaceInstallation);
    const {
      getStartedUrl,
      configureUrl
    } = buildProductCloudAppUrls({
      product,
      baseUrl,
      getStartedExtension,
      configExtension
    });
    const manageAppUrl = product === CompatibleProductId.COMPASS ? configureUrl : "".concat(baseUrl, "/plugins/servlet/upm#manage/").concat(marketplaceAppData.appKey);
    return _objectSpread(_objectSpread(_objectSpread({
      authType,
      details,
      installationId: marketplaceInstallation.id,
      enabled: true,
      manageAppUrl
    }, setProp('getStartedUrl', getStartedUrl)), setProp('configureUrl', configureUrl)), {}, {
      installTime: new Date(marketplaceInstallation.createdAt),
      scopes: marketplaceCloudAppDeployment.scopes.map(s => s.capability),
      latestVersion: !!((_marketplaceInstallat2 = marketplaceInstallation.appEnvironmentVersion) !== null && _marketplaceInstallat2 !== void 0 && _marketplaceInstallat2.isLatest),
      paymentModel,
      metadata: undefined,
      capabilitySet: (_marketplaceInstallat3 = marketplaceInstallation.license) === null || _marketplaceInstallat3 === void 0 ? void 0 : _marketplaceInstallat3.capabilitySet
    });
  }
  throw new Error("Marketplace app data not present in installed app ".concat(marketplaceInstallation.id));
};
export const transformInstalledCloudAppsGraphqlApiData = (product, baseUrl, appInstallations, globalSettingsExtensions) => {
  const globalSettingsExtensionsAppGroups = groupBy(globalSettingsExtensions, extension => extension.installationId);
  return appInstallations.filter(appInstall => {
    var _appInstall$app;
    return (_appInstall$app = appInstall.app) === null || _appInstall$app === void 0 ? void 0 : _appInstall$app.marketplaceApp;
  }).map(appInstall => toInstalledEcosystemCloudAddon(product, baseUrl, appInstall, globalSettingsExtensionsAppGroups[appInstall.id] || []));
};
// TODO: The types here are incorrect, return type should be Promise<GraphQLResponse<TData>>
export const postGraphQlRequest = async (payload, gqlGatewayUrl) => {
  const {
    query,
    variables,
    options = {}
  } = payload;
  const requestPayload = _objectSpread(_objectSpread({}, options), {}, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'atl-client-name': 'marketplace-amkt-upm-spi-impl'
    },
    body: JSON.stringify({
      query,
      variables
    })
  });
  const response = await fetchOk(gqlGatewayUrl, requestPayload);
  return response.json();
};
export const getRequestId = response => {
  var _response$extensions, _response$extensions$;
  return (response === null || response === void 0 ? void 0 : (_response$extensions = response.extensions) === null || _response$extensions === void 0 ? void 0 : (_response$extensions$ = _response$extensions.gateway) === null || _response$extensions$ === void 0 ? void 0 : _response$extensions$.request_id) || '';
};
export const checkEcosystemCloudAppInstallStatus = async (taskId, gqlGatewayUrl) => {
  const query = print(appInstallationTask);
  const variables = {
    id: taskId
  };
  const pollAfter = 5000;
  const options = {
    retries: calculateRetries(2, pollAfter),
    retryDelay: pollAfter,
    accept: response => response.json().then(bodyJSON => {
      var _bodyJSON$data, _bodyJSON$data$appIns;
      const appInstallationState = bodyJSON === null || bodyJSON === void 0 ? void 0 : (_bodyJSON$data = bodyJSON.data) === null || _bodyJSON$data === void 0 ? void 0 : (_bodyJSON$data$appIns = _bodyJSON$data.appInstallationTask) === null || _bodyJSON$data$appIns === void 0 ? void 0 : _bodyJSON$data$appIns.state;
      return appInstallationState === 'COMPLETE' || appInstallationState === 'FAILED' ? Promise.resolve() : Promise.reject(new Error('Request pending'));
    })
  };
  const responseJSON = await postGraphQlRequest({
    query,
    variables,
    options
  }, gqlGatewayUrl);
  const requestId = getRequestId(responseJSON);
  if (!responseJSON.data) {
    // requestId here can be used to trace the cause of issue in splunk logs for this query
    const error = new Error("App Installation Task Failed for taskId: ".concat(taskId));
    error.cause = requestId;
    throw error;
  }
  const data = _objectSpread(_objectSpread({}, responseJSON.data), {}, {
    requestId
  });
  return data;
};
export const buildSiteContext = (product, cloudId, activationId) => "ari:cloud:".concat(product, ":").concat(cloudId, ":workspace/").concat(activationId);